import { Component, inject, OnInit } from '@angular/core';
import { ModalContent, ModalRef } from '../../../modal-ref';
import {
  GoogleTagManagerService,
  POPUP_EVENT_ACTIONS,
  POPUP_EVENT_CATEGORY,
} from '../../../../services/google-tag-manager.service';
import { Payment } from 'payments-lib-types';
import { TranslatePipe } from '../../../../shared/translation/translate.pipe';
import {
  PaymentSsComponent,
} from '../../../../../page/account/account-cashier/payment-tab/components/payment-ss/payment-ss.component';
import { CUSTOM_ROUTES } from '../../../../vendor/ss-payments-v2/ss-payment-config';
import { PlatformService } from 'ngx-unificator/services';

@Component({
    selector: 'app-deposit-modal',
    templateUrl: './deposit-modal.component.html',
    styleUrls: ['./deposit-modal.component.scss'],
    imports: [TranslatePipe, PaymentSsComponent]
})
export class DepositModalComponent implements ModalContent, OnInit {
  private _gtm = inject(GoogleTagManagerService);
  private _platform = inject(PlatformService);


  public readonly DepositAction: Payment.Action = Payment.Action.Deposit;

  public Action: Payment.Action = Payment.Action.Deposit;

  /**
   * Access to parent modal
   */
  public modal: ModalRef;

  ngOnInit() {
    this._initCustomRoutes();
    this._gtm.popupEvent(
      POPUP_EVENT_CATEGORY.DEPOSIT_MODAL,
      POPUP_EVENT_ACTIONS.DEPOSIT_MODAL
    );
  }

  /**
   * Get modal content
   */
  get modalData(): any {
    return this.modal.options.data;
  }

  private _initCustomRoutes() {
    CUSTOM_ROUTES.successUrl = this._platform.isBrowser ? `${location.origin}/${this.modalData}` : `/${this.modalData}`;
    CUSTOM_ROUTES.pendingUrl = this._platform.isBrowser ? `${location.origin}/${this.modalData}` : `/${this.modalData}`;
    CUSTOM_ROUTES.failureUrl = this._platform.isBrowser ? `${location.origin}/payment-status/${this.DepositAction}/failure` : '/payment-status/deposit/failure';
    CUSTOM_ROUTES.supportUrl = this._platform.isBrowser ? `${location.origin}/faq` : '/faq'
  }

}
